import { getColumnKey } from './getColumnKey';
export const mapNamesToWidths = columns => columns.reduce((acc, {
  columnNamespace,
  columnName,
  width
}) => {
  acc[getColumnKey(columnNamespace, columnName)] = width;
  return acc;
}, {});